// DEPRECATED: see `useScreen` instead.
import { setupScreen } from '@consumer/helpers/screen'

const screen = setupScreen()

// DEPRECATED: see `useScreen` instead.
export const isPhone = toRef(screen, 'isPhone')
export const isMobile = toRef(screen, 'isMobile')
export const isDesktop = toRef(screen, 'isDesktop')
